module.exports = __webpack_public_path__ + "Oeuf.gif?00f936016e5a0943a7d68733bd986a4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Oeuf.gif
// module id = 135
// module chunks = 0